import React from 'react';
import { Page, useExecutiveCheckupRouter } from '../../router/context';
import * as S from './styles';
import ContainerPage from '../../../../components/ContainerPage';
import { Button } from '../../../../components';
import { ArrowLeft } from '../../../../components/Icons/ArrowLeft';

const doctorIcon =
  'https://agendamento-images-nprd.telemedicinaeinstein.com.br/illustrations/doctor-initial-assessments.svg';

const checkupInfo = {
  title: 'Vamos agendar seu check-up',
  infos: [
    {
      icon: 'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/services/estetoscopio.svg',
      text: 'Primeiro, você irá até uma unidade Einstein realizar sua consulta inicial e seus exames.'
    },

    {
      icon: 'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/calendar-rouded.svg',
      text: 'Após a realização de seus exames, você poderá agendar sua consulta de retorno com o clínico geral e equipe multidisciplinar.'
    }
  ]
};

const checkupInfoReturn = {
  title: 'Consultas complementares',
  infos: [
    {
      icon: 'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/services/estetoscopio.svg',
      text: 'Agora, você já pode agendar as consultas com cada profissional da equipe multidisciplinar, além do retorno com o Clínico Geral.'
    },
    {
      icon: 'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/calendar-rouded.svg',
      text: 'Suas consultas podem ser agendadas via telemedicina ou presencial, em uma unidade Einstein, dentro do prazo de 90 dias.'
    }
  ]
};

export type CheckUpInfoPageProps = {
  isFirstAppointment: boolean;
  firstAppointmentDate: string;
};
export function CheckUpInfoPage({ isFirstAppointment, firstAppointmentDate }: CheckUpInfoPageProps) {
  const router = useExecutiveCheckupRouter();

  const navigate = () => {
    if (isFirstAppointment) router.navigate(Page.APPOINTMENT_TYPE, { isFirstAppointment });
    else router.navigate(Page.PRODUCT_LIST, { isFirstAppointment, firstAppointmentDate });
  };

  const checkupInformations = isFirstAppointment ? checkupInfo : checkupInfoReturn;

  return (
    <ContainerPage childrenFooter={<Button title="Continuar" onClick={navigate} />}>
      <S.CloseWrapper>
        <div onClick={router.goBack}>
          <ArrowLeft />
          <S.CloseTitle>Voltar</S.CloseTitle>
        </div>
      </S.CloseWrapper>
      <S.Container>
        <img className="main-icon" src={doctorIcon} alt="warning" />
        <h3 className="title">{checkupInformations.title}</h3>
        <div className="breadcrumb">
          {checkupInformations.infos.map((item, index) => (
            <div className="row" key={index + item.icon}>
              <div className="line-base">
                <div className="line" />
                <img src={item.icon} />
              </div>
              <p className="info">{item.text}</p>
            </div>
          ))}
        </div>
      </S.Container>
    </ContainerPage>
  );
}
